export { TabComponent } from './tab.component'
